import React, {ReactNode, ReactNodeArray} from 'react';
import EpiComponent from '@episerver/spa-core/EpiComponent';
import BusinessReportBlockData from '../../../Models/Content/BusinessReportBlockData';
import './BusinessReport.scss';
import BusinessReportMain from './BusinessReportMain';

export default class BusinessReportBlock extends EpiComponent<BusinessReportBlockData> {
  public render(): ReactNode | ReactNodeArray | null {
    return <BusinessReportMain iContent={this.props.data} context={this.getContext()} />;
  }
}
